import { http, HttpResponse } from 'msw';

import { MockServiceWorker } from '../mockServiceWorker';

export const getDeclineReasonHandlers = [
    http.get('*/api/cl_loanapp_proxy_service/v1/:countryCode/offers/:arn/declined', async () => {
        const session = MockServiceWorker.getMockedSession();
        if (session.declineReason) {
            return HttpResponse.json([session.declineReason]);
        }
        return HttpResponse.json(['OTHER']);
    }),
];
